<template>
  <v-app>
    <router-view />
  </v-app>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "MicrositeBlanklayout",
  created() {
    this.changeWebsiteFont(null);
  },
  methods: {
    changeWebsiteFont(fontName) {
      let _fontName = fontName || "Default";
      if (_fontName == "Default") {
        document.documentElement.style.setProperty("--dynamic-font", "");
      } else {
        document.documentElement.style.setProperty("--dynamic-font", _fontName);
      }
    },
  },
  computed: {
    ...mapState("defaultSystem", ["site", "customer"]),
  },
};
</script>
